module.exports = __webpack_public_path__ + "static/media/YF97_8.4916d410.jpg";